import * as firebase from 'firebase/app';
require('firebase/firestore');
require('firebase/functions');

var config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_PROJECT_ID + ".firebaseapp.com",
  databaseURL: "https://" + process.env.VUE_APP_FIREBASE_PROJECT_ID + ".firebaseio.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_PROJECT_ID + ".appspot.com",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_ID
};

const FirebaseApp = firebase.initializeApp(config);

firebase.firestore();
firebase.functions();

console.log('Firebase Project ID: ', FirebaseApp.options.projectId);

export default {
  FirebaseApp: FirebaseApp
};